import { FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import { qrcodeAPIService } from '~/api/qrcode';
import { qrcodeQueryKeys } from '~/api/qrcode/queryKeys';
import { WebsiteMockup } from '~/components/atoms/mockup-previews/WebsiteMockup';
import { ConfirmNavigateModal } from '~/components/organisms/ConfirmNavigateModal';
import { DEFAULT_QR_CODE_STYLES } from '~/constants/common';
import { QRCODE_STATIC_STEP, QRCODE_STATIC_TYPE, QRCODE_STATUS } from '~/constants/qr-code';
import { PATH } from '~/constants/route-path';
import { useZodForm } from '~/hooks/useZodForm';
import { StaticQrContentLayout } from '~/pages/qrBuilder/p-static/components/static-qr-content-layout/StaticQrContentLayout';

import { StaticUrlForm } from './components/StaticUrlForm';
import { getSchema } from './utils/form-schema';

export const CreateStaticURLContent = () => {
  const navigate = useNavigate();
  const form = useZodForm({ getSchema });
  const url = form.watch('url');

  const mutation = useMutation({
    mutationFn: qrcodeAPIService.createStaticQrUrl,
    mutationKey: [qrcodeQueryKeys.createStaticQrUrl],
  });

  const onSubmit = (values) => {
    if (mutation.isPending) return;

    mutation.mutate(
      {
        body: {
          name: values.name,
          style: DEFAULT_QR_CODE_STYLES,
          status: QRCODE_STATUS.DRAFT,
          content: { url: values.url },
          ...(values.qrCodeFolder ? { folder_id: values.qrCodeFolder } : {}),
          // isPasswordProtected: values.passwordProtection.isPasswordProtected,
          // password: values.passwordProtection.password,
        },
      },
      {
        onSuccess: (res) => {
          window.dataLayer?.push({
            event: 'create_qr_code',
            qr_code_id: res?.id,
            qr_code_type: `static-${QRCODE_STATIC_TYPE.URL.toLowerCase()}`,
          });
          navigate(PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.STYLES, QRCODE_STATIC_TYPE.URL, res.data.id));
        },
      },
    );
  };

  const handleClickStep = async (step) => {
    if (step === 0) navigate(PATH.QR.CREATE); // on back click
    if (step === 2) await form.handleSubmit(onSubmit)(); // on next click
  };

  return (
    <FormProvider {...form}>
      <StaticQrContentLayout
        handleStep={handleClickStep}
        isNextProcessing={mutation.isPending}
        activeStep={1}
        qrCode={{}}
        mockup={<WebsiteMockup url={url} />}
        form={<StaticUrlForm />}
        isDisabledQrCodePreview
        isMobileQrButtonHidden
      />

      <ConfirmNavigateModal activeStep={1} />
    </FormProvider>
  );
};
